import { GUEST_LOGIN } from "../../utils/keywords"
import { createSlice } from "@reduxjs/toolkit"
import { fetchExchangeRate } from "./common.slice"

const initialState = {
  type: "",
  data: {},
  toast: {},
  show: false,
  loadings: {},
  refresh: true,
  specializations: [],
  exchangeRate: null,}
const other = createSlice({
  name: "other",
  initialState,
  extraReducers: (builder) => {
    // handle reatrieve all
    builder.addCase("retrieveAll/pending", (state) => {
      state.loadings.retrieveAll = true
    })

    builder.addCase("retrieveAll/rejected", (state) => {
      delete state?.loadings?.retrieveAll
    })


    //for  specialiaztion 
    builder.addCase("retrieveAll/fulfilled", (state, action) => {
      delete state?.loadings?.retrieveAll
      state.specializations = action.payload?.data || []
    })
    // handle reatrieve single
    builder.addCase("retrieveSingle/pending", (state) => {
      state.loadings.retrieveSingle = true
    })
    builder.addCase("retrieveSingle/fulfilled", (state) => {
      delete state?.loadings?.retrieveSingle
    })
    builder.addCase("retrieveSingle/rejected", (state) => {
      delete state?.loadings?.retrieveSingle
    })

    // handle create
    builder.addCase("create/pending", (state) => {
      state.loadings.create = true
    })
    builder.addCase("create/fulfilled", (state) => {
      delete state?.loadings?.create
    })
    builder.addCase("create/rejected", (state) => {
      delete state?.loadings?.create
    })

    // handle update
    builder.addCase("update/pending", (state) => {
      state.loadings.update = true
    })
    builder.addCase("update/fulfilled", (state) => {
      delete state?.loadings?.update
    })
    builder.addCase("update/rejected", (state) => {
      delete state?.loadings?.update
    })

    // handle delete
    builder.addCase("delete/pending", (state) => {
      state.loadings.delete = true
    })
    builder.addCase("delete/fulfilled", (state) => {
      delete state?.loadings?.delete
    })
    builder.addCase("delete/rejected", (state) => {
      delete state?.loadings?.delete
    })
    builder.addCase("forum/create/pending", (state, action) => {
      const isDraft = action.meta.arg?.isDraft
      state.loadings[isDraft ? "create_draft" : "create_publish"] = true
    })
    builder.addCase("forum/create/fulfilled", (state, action) => {
      const isDraft = action.meta.arg?.isDraft
      delete state.loadings[isDraft ? "create_draft" : "create_publish"]
    })
    builder.addCase("forum/create/rejected", (state, action) => {
      const isDraft = action.meta.arg?.isDraft
      delete state.loadings[isDraft ? "create_draft" : "create_publish"]
    })
    builder.addCase("accept/pending", (state) => {
      state.loadings.accept = true;
    });
    builder.addCase("accept/fulfilled", (state) => {
      delete state?.loadings?.accept;
    });
    builder.addCase("accept/rejected", (state) => {
      delete state?.loadings?.accept;
    });

    // Handle reject appointment
    builder.addCase("reject/pending", (state) => {
      state.loadings.reject = true;
    });
    builder.addCase("reject/fulfilled", (state) => {
      delete state?.loadings?.reject;
    });
    builder.addCase("reject/rejected", (state) => {
      delete state?.loadings?.reject;
    });

    // Handle cancel  appointment
    builder.addCase("cancel/pending", (state) => {
      state.loadings.reject = true;
    });
    builder.addCase("cancel/fulfilled", (state) => {
      delete state?.loadings?.reject;
    });
    builder.addCase("cancel/rejected", (state) => {
      delete state?.loadings?.reject;
    });

    // Handle rejectall appointment
    builder.addCase("rejectAll/pending", (state) => {
      state.loadings.rejectAll = true;
    });
    builder.addCase("rejectAll/fulfilled", (state) => {
      delete state?.loadings?.rejectAll;
    });
    builder.addCase("rejectAll/rejected", (state) => {
      delete state?.loadings?.rejectAll;
    });

    builder.addCase(fetchExchangeRate.fulfilled, (state, action) => {
      state.exchangeRate = action.payload || null;
    });
  },
  reducers: {
    // Dialogs
    showDialogWithData: (state, { payload }) => {
      state.show = true
      state.type = payload?.type
      state.data = { ...payload?.data }
    },
    showDialog: (state, { payload }) => {
      state.show = true
      state.type = payload
    },
    hideDialog: (state) => {
      state.type = ""
      state.data = {}
      state.show = false
      state.categoryId = null
    },
    guestLoginFlow: (state) => {
      state.show = true
      state.type = GUEST_LOGIN
    },

    // Toaster
    toastError: (state, { payload }) => {
      state.toast.show = true
      state.toast.msg = payload
      state.toast.severity = "error"
    },
    toastSuccess: (state, { payload }) => {
      state.toast.show = true
      state.toast.msg = payload
      state.toast.severity = "success"
    },
    toastHide: (state) => {
      delete state?.toast?.show
    },

    showToast: (state, { payload }) => {
      state.toast = {
        show: true,
        message: payload.message,
        type: payload.type || "success",
        duration: payload.duration || 2000,
      }
    },
    hideToast: (state) => {
      state.toast.show = false
    },

    refresher: (state) => {
      state.refresh = !state.refresh
    }
    ,


    resetBookingStatus: (state) => {
      state.bookingsByWebinar = {};
    }


  },
})

export const {
  toastSuccess, toastHide, toastError,
  showDialogWithData, showDialog, hideDialog,
  showToast, hideToast, refresher, guestLoginFlow,
  setBookingStatus, resetBookingStatus,
} = other.actions
export default other.reducer